const CheshmAndaz = () => {
  return (
    <>
      <ul>
        <li>تولیدکننده برتر فرآورده های آلومینیومی</li>
        <li>حضور گسترده تر در بازارهای منطقه ای</li>
        <li>جذب و ایجاد شبکه ای از مشتریان وفادار و مبلغ</li>
        <li>ایجاد حس بالندگی و غرور بین همکاران سازمانی مان</li>
      </ul>
    </>
  );
};

export default CheshmAndaz;
